export default "__VITE_ASSET__AIZhOB9d__"